export default class CardName {
  constructor(contents) {
    if(!contents)return false;
    this.name = contents.querySelectorAll('.c-card__name');

    this.height = [];

    this.setup()
  }

  setup () {

    this.name.forEach((elm, index) => {
      if(index%4==0)
      {
        this.height[Math.floor(index/4)] = elm.clientHeight;
      }
      else
      {
        if(this.height[Math.floor(index/4)]<elm.clientHeight)
        {
          this.height[Math.floor(index/4)] = elm.clientHeight;
        }
      }
    });
    this.name.forEach((elm, index) => {
      elm.style.height = this.height[Math.floor(index/4)]+"px";
    });
  }

}